<template>

  <div class="wizard_container">
    <v-icon 
      class   = "wizard_icon mb-4" 
      size    = "100"
      :color  = "color"
    >
      {{ icon }}
    </v-icon>
    <div class="wizard_text">
      <slot></slot>
    </div>
  </div>

</template>

<script lang="js">

export default {

  // #region Properties

  name:  'Wizard',
  props: {
    icon:  String,
    color: String
  }

  // #endregion Properties

}

</script>

<style lang="scss" scoped>

@import "../../../styles/colors.scss";

.wizard_container {
  display:          flex;
  flex-direction:   column;
  align-items:      center;
  justify-content:  center;
  overflow:         hidden;

  .wizard_text {
    color:            $label-color;
  }

  .wizard_icon {
    color:            $darker-label-color;
  }
}

</style>